import { createFileRoute } from "@tanstack/react-router";
import { CompaniesPage } from "@/features/admin/companies-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/spolki")({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.system.spolki", location.pathname);
	},
	component: CompaniesPage,
});
